export interface ReviewAndRating {
  sn: number;
  reviewId: string;
  invoiceId: string;
  nickname: string;
  ratingScale: number;
  englishRemark: string;
  japaneseRemark: string;
  remarkType: string;
  message: string;
  storeNameEng: string;
  storeNameJp: string;
  clubImageResponse: {
    alt: string;
    description: string;
    path: string;
  };
  postedDate: number;
  visitingDateTime: number;
  endingDateTime: number;
}

export interface RatingsPreview {
  customerInfo: {
    customerImageResponse: {
      alt: string;
      description: string;
      path: string;
    };
    ratingScale: number;
    nickName: string;
    visitingDateTime: number;
    endingDateTime: number;
    isCourseExtended?: boolean;
  };
  clubReviewRatings: {
    englishRemark: string;
    japaneseRemark: string;
    remarkType: string;
  }[];
  hostReviewRatings: {
    hostId: number;
    hostName: string;
    hostImageResponse: {
      alt: string;
      description: string;
      path: string;
    };
    isRankedOne: boolean;
  }[];
  intentRemarks: {
    intentEnglishRemark: string;
    intentJapaneseRemark: string;
    intentRemarkType: string;
  }[];
  qnaRemarks: {
    qnaEngQuestion: string;
    qnaJpQuestion: string;
    qnaJpShortQuestion: string;
    qnaEngAnswer: string;
    qnaJpAnswer: string;
  }[];
}

export interface Inquiry {
  sn: number;
  inquiryId: string;
  nickName: string;
  email: string;
  phoneNumber: string;
  inquiryType: string;
  message: string;
  createdDate: string;
}

export interface InquiryDetails {
  inquiryId: string;
  nickName: string;
  emailAddress: string;
  phoneNumber: string;
  inquiryType: string;
  companyName: string;
  subject: string;
  message: string;
  postedDate: number;
  attachment: {
    alt: string;
    description: string;
    path: string;
  };
}

export interface mainPage {
  sn: number;
  groupInfo: string;
  totalStores: string;
  status: string;
  createdDate: string;
  updatedDate: string;
  remarks: string;
}

export interface InquiryDetailsParams {
  inquiryId?: string;
}

export interface FaqParams {
  row?: number;
  fetch?: number;
  fromDate?: number;
  toDate?: number;
  createdDate?: number;
  search?: string;
  ratingsFilter?: number;
}

export enum RATING_FILTER {
  One = '1',
  Two = '2',
  Three = '3',
  Four = '4',
  Five = '5',
}
// API_ACTION_TYPES
